import React, { useState, useEffect } from 'react'
import LoadingScreen from 'react-loading-screen'
import logo from "assets/img/logo/logo_aig_login-2.png";

import { Card, CardBody, Row, Col, Button, CardTitle, Alert } from "reactstrap";
import { urlEnviarCorreoRCA,urlGuardarLeadFacturacion } from '../../constants/urls'
import { apiPost } from '../../api'
import EsRenovacion, { guardarRenovacion } from '../EsRenovacion/EsRenovacion';
const Resumen = (props) => {
    const [correo, setCorreo] = useState('');
    const [loading, setLoading] = useState(false);
    const [imp, setImp] = useState(false);
    const [mensaje, setMensaje] = useState(false);
    const [msjEmail, setMsjEmail] = useState(false);
    const [claseDivFix, setClaseDivFix] = useState('flex-row div-flotante');    

    //es Renovacion
    const [esRenovacion, setEsRenovacion] = useState(false)
    const [numPolizaVence, setNumPolizaVence] = useState(null)
    const [tieneError, setTieneError] = useState(true)


    const onClickContinuar = async () => {

        setTieneError(!tieneError)

        if ((!esRenovacion) || (esRenovacion && !tieneError)) {

            guardarRenovacion(esRenovacion, props.idCarrito, numPolizaVence)
            setLoading(true)
            let param = {
                empresa: "AIGMETROPOLITANA",
                plataforma: "WEB",
                idCarrito: props.idCarrito
            }
            try {
                let res = await apiPost(urlGuardarLeadFacturacion, param)
                if (res.transaccion) {
                    props.redireccionar();
                }
            } catch (e) {
                alert('Ha ocurrido un error por favor intentar nuevamente')
            }
            setLoading(false)
            //props.redireccionar();    

        }


    }




    const enviarEmail = async () => {

        // correo
        var reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;

        if (reg.test(correo) == false) {
            setMsjEmail(true)
            setTimeout(() => setMsjEmail(false), 4000)
        } else {
            setLoading(true)
            const { idCarrito } = props
            const param = { idCarrito, accion: 'enviar', correo }
            const data = await apiPost(urlEnviarCorreoRCA, param)
            console.log(data)
            setLoading(false)
            setMensaje(true)
            setTimeout(() => setMensaje(false), 5000)
        }
    }
    useEffect(() => {
        window.addEventListener("scroll", handleScroll);
        window.scroll(0, 0)
        return () => {
            window.removeEventListener("scroll", handleScroll);
        }
    }, [])

    const handleScroll = () => {
        const windowHeight = "innerHeight" in window ? window.innerHeight : document.documentElement.offsetHeight;
        const body = document.body;
        const html = document.documentElement;
        const docHeight = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
        const windowBottom = windowHeight + window.pageYOffset;

        if (windowBottom >= (docHeight - 300)) setClaseDivFix('flex-row div-flotante fix-botton-totales-resumen-multi')
        else setClaseDivFix('flex-row div-flotante')


    }
    const { carProductos, valorTotal, rucEmpresa, nomEmpresa, nombres, apellidos, carUrlPdf } = props    
    console.log("urlpdf", carUrlPdf)
    let habilitarBtnFacturacion=false    
    for (let i = 0; i < carProductos.length; i++) 
    {    
        if(carProductos[i].datosProducto  && carProductos[i].datosProducto.marcaNombre === undefined)
        {
            habilitarBtnFacturacion=true 
        }
    }
    return (
        <LoadingScreen
            loading={loading}
            bgColor="#f1f1f1"
            spinnerColor="#001871"
            textColor="#676767"
            logoSrc={logo}
            text="Cargando..."
            logo={''}
        >
            <div>
                <Row>
                    <Col md={8}>
                        <Button className="btn btn-purple" style={{ display: 'block', margin: '0px 0px 0px auto', }} onClick={() => props.agregarVehiculo()}>
                            <i className="fa fa-plus-circle" aria-hidden="true" /> AGREGAR VEHÍCULO
                        </Button>
                    </Col>
                    <Col md={8}></Col>
                </Row>
                <Row>
                    <Col md={8} >
                        <Card style={{ padding: 10 }}>
                            <CardBody>
                                <CardTitle> <div style={{ fontWeight: 'bold', fontSize: '1.80rem' }}> Datos del contratante </div></CardTitle>
                                <Row>
                                    <Col md={4} > <h4 style={{ fontWeight: 500, }}  >Identificación</h4></Col>
                                    <Col md={8} > <div className={"input-type-label form-control"} >{rucEmpresa}</div></Col>
                                </Row>
                                <Row>
                                    <Col md={4} > <h4 style={{ fontWeight: 500, }} >Nombre/Razón social</h4></Col>
                                    <Col md={8} > <div className={"input-type-label form-control"} >{nomEmpresa || (`${nombres} ${apellidos}`)}</div></Col>
                                </Row>
                                <Button className="btn btn-detail-gray" onClick={() => props.handleBack({ paso: 'inicio' })} style={{ display: "block", margin: '0 0 0 auto', }} >
                                    <i className="fa fa-pencil" aria-hidden="true" />{" EDITAR"}
                                </Button>
                            </CardBody>
                        </Card>

                        <hr />
                        {carProductos && carProductos.length > 0 && carProductos.map(({ datosProducto, datosCliente, totales }, i) =>                        
                            <Card style={{ padding: 10 }} key={Math.random() + 'wqew'} >
                                <CardBody>
                                    <CardTitle style={{}} > <div style={{ fontWeight: 'bold', fontSize: '1.80rem' }}> Datos del Vehículo #{i + 1}</div>
                                    </CardTitle>
                                    {/* {console.log('datosProducto:', datosProducto)} */}
                                    {!datosProducto.marcaNombre && <Row>
                                        <Col md={12}> <Alert color="warning"> Debe completar o eliminar el producto para continuar</Alert> </Col>
                                    </Row>}
                                    <Row>
                                        <Col md={4} style={{ marginBottom: 0, }} > <h4 style={{ fontWeight: 500, }} >Marca</h4></Col>
                                        <Col md={8} style={{ marginBottom: 0, }} > <div className={"input-type-label form-control"} >{datosProducto.marcaNombre}</div></Col>
                                    </Row>
                                    <Row>
                                        <Col md={4} style={{ marginBottom: 0, }} > <h4 style={{ fontWeight: 500, }} >Modelo</h4></Col>
                                        <Col md={8} style={{ marginBottom: 0, }} > <div className={"input-type-label form-control"} >{datosProducto.modeloNombre}</div></Col>
                                    </Row>
                                    <Row>
                                        <Col md={4} style={{ marginBottom: 0, }} > <h4 style={{ fontWeight: 500, }} >Categoría</h4></Col>
                                        <Col md={8} style={{ marginBottom: 0, }} > <div className={"input-type-label form-control"} >{datosProducto.categoriaNombre}</div></Col>
                                    </Row>
                                    <Row>
                                        <Col md={4} style={{ marginBottom: 0, }} > <h4 style={{ fontWeight: 500, }} >Placa</h4></Col>
                                        <Col md={3} style={{ marginBottom: 0, }} > <div className={"input-type-label form-control"} >{datosProducto.placa} </div></Col>
                                        <Col md={2} style={{ marginBottom: 0, }} > <h4 style={{ fontWeight: 500, }} >Año</h4></Col>
                                        <Col md={2} style={{ marginBottom: 0, }} > <div className={"input-type-label form-control"} >{datosProducto.anio}</div></Col>
                                    </Row>
                                    <Row>
                                        <Col md={4} style={{ marginBottom: 0, }} > <h4 style={{ fontWeight: 500, }} >Motor</h4></Col>
                                        <Col md={8} style={{ marginBottom: 0, }} > <div className={"input-type-label form-control"} >{datosProducto.motor}</div></Col>
                                    </Row>
                                    <Row>
                                        <Col md={4} style={{ marginBottom: 0, }} > <h4 style={{ fontWeight: 500, }} >Chasis</h4></Col>
                                        <Col md={8} style={{ marginBottom: 0, }} > <div className={"input-type-label form-control"} >{datosProducto.chasis}</div></Col>
                                    </Row>
                                    <Row>
                                        <Col md={4} style={{ marginBottom: 0, }} > <h4 style={{ fontWeight: 500, }} >Color</h4></Col>
                                        <Col md={8} style={{ marginBottom: 0, }} > <div className={"input-type-label form-control"} >{datosProducto.colorNombre}</div></Col>
                                    </Row>
                                    <Row>
                                        <Col md={4} style={{ marginBottom: 0, }} > <h4 style={{ fontWeight: 500, }} >Procedencia</h4></Col>
                                        <Col md={8} style={{ marginBottom: 0, }} > <div className={"input-type-label form-control"} >{datosProducto.procedenciaNombre}</div></Col>
                                    </Row>
                                    <hr />
                                    {datosCliente && <>
                                        <CardTitle> <div style={{ fontWeight: 'bold', fontSize: '1.80rem', }}> Datos del Conductor </div></CardTitle>
                                        <Row>
                                            <Col md={4} style={{ marginBottom: 0, }} > <h4 style={{ fontWeight: 500, }} >Cédula/Ruc</h4></Col>
                                            <Col md={8} style={{ marginBottom: 0, }} > <div className={"input-type-label form-control"} >{datosCliente.cedulaConductor}</div></Col>
                                        </Row>
                                        <Row>
                                            <Col md={4} style={{ marginBottom: 0, }} > <h4 style={{ fontWeight: 500, }} >Nombre</h4></Col>
                                            <Col md={8} style={{ marginBottom: 0, }} > <div className={"input-type-label form-control"} >{datosCliente.nombreConductor}</div></Col>
                                        </Row>
                                    </>}

                                    {totales && <> <hr />
                                        <Row>
                                            <Col md={4} style={{ marginBottom: 0, }} > <h4 style={{ fontWeight: 'bold' }} >Prima Neta</h4></Col>
                                            <Col md={8} style={{ marginBottom: 0, }} > <div >${totales.prima_neta_anual_full_cobertura}</div></Col>
                                        </Row>
                                    </>}
                                    <Row>
                                        <Col style={{ display: 'contents' }} > <div style={{ display: "block", margin: '0 0 0 auto', }}>

                                            <Button className="btn btn-detail-gray" onClick={() => props.handleBack({ placa: datosProducto.placa, codProducto: datosProducto.codProducto, datosProducto, datosCliente, })} >
                                                <i className="fa fa-pencil" aria-hidden="true" />{" EDITAR"}
                                            </Button>{`  `}
                                            <Button className="btn btn-detail-white" onClick={() => props.handleEliminar({ codProducto: datosProducto.codProducto })} >
                                                <i className="fa fa-trash" aria-hidden="true" />{" ELIMINAR"}
                                            </Button>
                                        </div>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>)}

                        <EsRenovacion
                            esRenovacion={esRenovacion}
                            setEsRenovacion={(esRenovacion) => {
                                setEsRenovacion(esRenovacion)
                            }}
                            numPolizaVence={numPolizaVence}
                            setNumPolizaVence={(value) => {
                                setNumPolizaVence(value)
                            }}
                            tieneError={tieneError}
                            setTieneError={(value) => {
                                setTieneError(value)
                            }}
                        />





                    </Col>
                    <Col md={4} className='detalle-impuestos-box'>
                        <Card style={{ padding: 10 }} className={claseDivFix}>
                            <CardBody>
                                <CardTitle> <div style={{ fontWeight: 'bold', fontSize: '1.80rem', }}> Valor del seguro </div></CardTitle>
                                <Row>
                                    <Col md={8} > <h4 style={{}} > Prima Neta</h4></Col>
                                    <Col md={4}  > {valorTotal && <div className={"float-right"} >${valorTotal.prima_neta_anual_full_cobertura}</div>}</Col>
                                </Row>
                                <Row>
                                    <Col md={8} > <div onClick={() => setImp(!imp)}>  <h4 style={{}} > {`Impuestos  `}  <i className="fa fa-info-circle" aria-hidden="true" /></h4></div> </Col>
                                    <Col md={4}  > {valorTotal && <div className={"float-right"} >${valorTotal.totalImpuestos}</div>}</Col>
                                </Row>

                                {imp && valorTotal && valorTotal.arrayImpuestos.map(({ codigo, nombre, valor }) =>
                                    <Row key={codigo}>
                                        <Col md={8} > <h4 style={{}} > {nombre}</h4></Col>
                                        <Col md={4}  > <div className={"float-right"} >${valor}</div></Col>
                                    </Row>
                                )}

                                <Row>
                                    <Col md={8} > <h4 style={{ fontWeight: 'bold' }} > Prima Total</h4></Col>
                                    <Col md={4}  >{valorTotal && <div className={"float-right"} >${valorTotal.totalcarrito}</div>}</Col>
                                </Row>
                                <hr />
                                <Button
                                    disabled ={habilitarBtnFacturacion}                                                                  
                                    //disabled
                                    className="btn btn-primary "
                                    style={{ display: 'block', margin: 'auto', }}
                                    //  onClick={() => { this.setState({ validate: true }); this.onClickContinuar() }}>
                                    onClick={() => onClickContinuar()}> 
                                    <i className="fa fa-chevron-circle-right" aria-hidden="true" />{` INICIAR EMISIÓN`}
                                </Button>



                                <a href={carUrlPdf} target="_blank" className="btn btn-detail-white" style={{ marginTop: 20, }} >
                                    <i className="fa fa-cloud-download" aria-hidden="true" /> DESCARGAR COTIZACIÓN
                                    </a>

                                <div className='row' style={{ marginTop: 20, }}>

                                    <Col lg={8} md={12} sm={12} xs={12}>
                                        <input className="form-control" placeholder="Por favor ingrese el correo" value={correo} onChange={({ target }) => setCorreo(target.value)}>
                                        </input>
                                        {msjEmail && <Alert color="danger">
                                            Ingrese correctamente el correo electrónico.
                                        </Alert>}
                                    </Col>
                                    <Col lg={4} md={12} sm={12} xs={12}>
                                        <Button className="btn btn-detail-white" onClick={() => enviarEmail()}>
                                            <i className="fa fa-paper-plane-o" aria-hidden="true" /> ENVIAR
                                            </Button>

                                    </Col>
                                    {mensaje &&
                                        <Alert color="success">
                                            <center><p>Se ha enviado correctamente la cotización al correo electrónico ingresado.</p></center>
                                        </Alert>
                                    }
                                </div>

                            </CardBody>
                        </Card>
                    </Col>
                </Row>

            </div>
        </LoadingScreen >

    )
}

export default Resumen